import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type DialogVariant = 'info' | 'danger';

export type DialogState = {
  isOpen: boolean;
  mode: 'alert' | 'confirm';
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel?: string;
  variant: DialogVariant;
};

const DEFAULT_STATE: DialogState = {
  isOpen: false,
  mode: 'alert',
  title: '',
  message: '',
  confirmLabel: 'OK',
  cancelLabel: 'Annulla',
  variant: 'info'
};

@Injectable({ providedIn: 'root' })
export class DialogService {
  readonly state$ = new BehaviorSubject<DialogState>(DEFAULT_STATE);
  private resolver: ((value: boolean) => void) | null = null;

  alert(
    message: string,
    options?: Partial<Pick<DialogState, 'title' | 'confirmLabel' | 'variant'>>
  ): Promise<void> {
    return new Promise<void>((resolve) => {
      this.resolver = () => resolve();
      this.state$.next({
        isOpen: true,
        mode: 'alert',
        title: options?.title || 'Messaggio',
        message,
        confirmLabel: options?.confirmLabel || 'Chiudi',
        cancelLabel: undefined,
        variant: options?.variant || 'info'
      });
    });
  }

  confirm(
    message: string,
    options?: Partial<Pick<DialogState, 'title' | 'confirmLabel' | 'cancelLabel' | 'variant'>>
  ): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.resolver = resolve;
      this.state$.next({
        isOpen: true,
        mode: 'confirm',
        title: options?.title || 'Conferma azione',
        message,
        confirmLabel: options?.confirmLabel || 'Conferma',
        cancelLabel: options?.cancelLabel || 'Annulla',
        variant: options?.variant || 'info'
      });
    });
  }

  resolve(result: boolean): void {
    const pending = this.resolver;
    this.resolver = null;
    this.state$.next(DEFAULT_STATE);
    pending?.(result);
  }
}
